import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import debounce from "lodash/debounce";

import TextInput from "@stadium/ui/src/components/form/TextInput";
import Label from "@stadium/ui/src/components/form/Label";

import { useCartListingContext } from "@contexts/cart-listing-context";

import { getCartOrderBundleName } from "@selectors/cart";

import styles from "./main.module.scss";

const ITEM_NAME_CHAR_LIMIT = 50;

const SendToOthersItemName = () => {
  const bundleName = useSelector(getCartOrderBundleName);

  const { sendToOtherItemName, setSendToOtherItemName } = useCartListingContext();

  const [itemName, setItemName] = useState(sendToOtherItemName);

  const itemNameChangeHandler = useCallback(
    debounce((value) => {
      setSendToOtherItemName(value);
    }, 1000),
    [],
  );

  useEffect(() => {
    itemNameChangeHandler(itemName);
  }, [itemName]);

  useEffect(() => {
    setItemName(bundleName);
  }, [bundleName]);

  const renderOptionalInputItem = () => (
    <div className={styles.optionalItemBlock}>
      <TextInput
        id="itemName"
        label={
          <Label htmlFor="itemName" showIcon={false} className={styles.labelName}>
            Name Your Items (optional)
          </Label>
        }
        value={itemName}
        onChange={({ value }) => setItemName(value)}
        maxLength={ITEM_NAME_CHAR_LIMIT}
        className={styles.inputTextField}
        classes=""
      />
    </div>
  );
  return renderOptionalInputItem();
};
export default SendToOthersItemName;
